<template>
  <div>
    <div v-for="(item, key) in quickBars" :key="key" class="link-item brush-item">
      <div class="link-item-name" @click="goHelpCenter(item)">
        <div class="link-item-image">
          <img :src="item.image" alt="">
        </div>
        <div class="link-item-text">
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleHelpCenterLink } from '@/utils/tool'

export default {
  data() {
    return {
      quickBars: []
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    },
    banner() {
      return this.$store.state.brand?.banners?.[0] || null
    },
    licenseId() {
      return this.banner?.link.match(/licence\/(\d+)/)?.[1] || null
    }
  },
  watch: {
    licenseId(newVal) {
      if (newVal) {
        this.initLiveChat()
      }
    }
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.quickBars = this.$store.state.brand.quickBars.filter((item) => {
          return item.type === 'web'
        })
      }, 1000)
    })
  },
  mounted() {
    if (this.licenseId !== null) {
      this.initLiveChat()
    }
  },
  methods: {
    initLiveChat() {
      // licenseId : KT: 16229799
      // licenseId : UB: 19394384
      window.__lc = window.__lc || {}
      window.__lc.license = this.licenseId

      ;(function(n, t, c) {
        function i(n) { return e._h ? e._h.apply(null, n) : e._q.push(n) } var e = { _q: [], _h: null, _v: '2.0', on: function() { i(['on', c.call(arguments)]) }, once: function() { i(['once', c.call(arguments)]) }, off: function() { i(['off', c.call(arguments)]) }, get: function() { if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load."); return i(['get', c.call(arguments)]) }, call: function() { i(['call', c.call(arguments)]) }, init: function() {
          var n = t.createElement('script'); n.async = !0; n.type = 'text/javascript'; n.src = 'https://cdn.livechatinc.com/tracking.js'; t.head.appendChild(n)
        } }; !n.__lc.asyncInit && e.init(); n.LiveChatWidget = n.LiveChatWidget || e
      }(window, document, [].slice))

      function onVisibilityChanged(data) {
        switch (data.visibility) {
          case 'minimized':
            LiveChatWidget.call('hide')
            break
          case 'hidden':
            break
        }
      }

      // Wait for LiveChatWidget to be ready before setting up events and hiding
      LiveChatWidget.on('ready', () => {
        LiveChatWidget.on('visibility_changed', onVisibilityChanged)
        LiveChatWidget.call('hide')
      })
    },
    goHelpCenter(item) {
      const isGuest = !this.token
      const user = this.$store.state.user
      const userInfo = this.$store.state.user.memberInfo
      const vipInfo = this.$store.state.user.vipInfo
      const dateFormatter = this.$options.filters.dateFormat

      handleHelpCenterLink(isGuest, item, user, userInfo, vipInfo, dateFormatter)
    }
  }

}
</script>

